import { SVGElement } from "@ui/types";
import { LucideIcon } from "lucide-react";
import { ReactNode } from "react";

export function EmptyState(props: {
  title: ReactNode;
  description: ReactNode;
  action?: ReactNode;
  icon?: SVGElement | LucideIcon;
}) {
  return (
    <div className="text-center">
      {props.icon && <props.icon className="w-12 h-12 mx-auto text-muted-foreground/70" />}

      <h3 className="mt-2 text-lg font-medium text-foreground">{props.title}</h3>
      <p className="mt-1 text-sm text-muted-foreground">{props.description}</p>
      {props.action && <div className="mt-6">{props.action}</div>}
    </div>
  );
}

export default EmptyState;
